// extracted by mini-css-extract-plugin
export default {"overflowMenu":"OverflowMenu_overflowMenu__TxjGX","container":"OverflowMenu_container__0XR+R","popoverContainer":"OverflowMenu_popoverContainer__8oj8J"};